import { DatePicker, Form } from 'antd'
import moment from 'moment'
import { Field } from 'react-final-form'
import { useStrings } from '../../../hooks/useStrings'

const { RangePicker } = DatePicker

const DateInput = ({
  name,
  label,
  validate = [],
  inputProps = {},
  FormItemProps = {},
}) => {
  const { lng } = useStrings('components', 'DateInput')

  return (
    <Field
      name={name}
      render={({ input }) => (
        <Form.Item
          label={label}
          name={name}
          rules={validate}
          {...FormItemProps}>
          <RangePicker
            {...input}
            {...inputProps}
            ranges={{
              [lng('today')]: [moment().startOf('day'), moment().endOf('day')],
              [lng('thisMonth')]: [
                moment().startOf('month'),
                moment().endOf('month'),
              ],
              [lng('thisYear')]: [
                moment().startOf('year'),
                moment().endOf('year'),
              ],
              [lng('yesterday')]: [
                moment().subtract(1, 'day').startOf('day'),
                moment().subtract(1, 'day').endOf('day'),
              ],
              [lng('lastMonth')]: [
                moment().subtract(1, 'month').startOf('month'),
                moment().subtract(1, 'month').endOf('month'),
              ],
              [lng('lastYear')]: [
                moment().subtract(1, 'year').startOf('year'),
                moment().subtract(1, 'year').endOf('year'),
              ],
            }}
          />
        </Form.Item>
      )}
    />
  )
}

export default DateInput
